var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof search_and_view !== "undefined") return resolve();
	__webpack_require__.l("https://search-and-view.myacertus.com/remoteEntry.js", (event) => {
		if(typeof search_and_view !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "search_and_view");
}).then(() => (search_and_view));